import PendingQuestionsAPI from 'dashboard/api/omni/pendingQuestions';

const state = {
  count: 0,
  isLoading: false,
};

const getters = {
  getCount: _state => _state.count,
  isLoading: _state => _state.isLoading,
};

const mutations = {
  SET_COUNT(_state, count) {
    _state.count = count;
  },
  SET_LOADING(_state, isLoading) {
    _state.isLoading = isLoading;
  },
};

const actions = {
  setCount({ commit }, count) {
    commit('SET_COUNT', count);
  },

  async fetchCount({ commit }) {
    commit('SET_LOADING', true);
    try {
      const { data } = await PendingQuestionsAPI.get({ status: 'pending' });
      const count = data.meta?.pending_count || data.payload?.length || 0;
      commit('SET_COUNT', count);
    } catch (error) {
      // Silently fail - don't break the app if this fails
      console.error('Error fetching pending questions count:', error);
    } finally {
      commit('SET_LOADING', false);
    }
  },

  decrement({ commit, state: _state }) {
    const newCount = Math.max(0, _state.count - 1);
    commit('SET_COUNT', newCount);
  },

  increment({ commit, state: _state }) {
    commit('SET_COUNT', _state.count + 1);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

